import React, { useState, useEffect }  from 'react'
import {
  useHistory,
  useLocation,
  useParams
} from 'react-router'
import {
  Card,
  CardBody,
  Col,
  Row
} from 'reactstrap'
import { TitlePage } from 'components/atoms'
import { CardLoader } from 'components/organisms'
import { RevenueTransferForm } from 'domains/revenue/organisms'
import RevenuesApiV2 from 'api/v2/admins/revenues-api-v2'
import withLoader from 'hocs/with-loader'
import { ALERT_TYPES } from 'constants/alert-constants'
import PropTypes from 'prop-types'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const RevenueTransferPage = ({ pageUtils }) => {

  const { id }                      = useParams()
  const history                     = useHistory()
  const location                    = useLocation()
  const [ revenue, setRevenue ]     = useState({})
  const [ isLoading, setIsLoading ] = useState(true)

  useEffect(() => {
    const revenue = location.state

    setRevenue(revenue)
    setIsLoading(false)
  }, [ location.state ])

  const handleSubmitForm = async (values) => {
    await RevenuesApiV2.patchTransferRevenue({
      id,
      values
    })
      .then(() => {
        pageUtils.setAlertMsg('Sucessfully confirm transfer revenue!', ALERT_TYPES.SUCCESS)
        history.push('/app/cms/homepage/sections')
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }

  const RevenueTransferFormWithLoader = withLoader(RevenueTransferForm , CardLoader)

  return (
    <Row>
      <Col lg={{ size: 8, offset: 2 }}>
        <TitlePage mainTitle='Revenue Transfer Page' subTitle='#' />
        <Card>
          <CardBody>
            <RevenueTransferFormWithLoader
              isLoading={ isLoading }
              revenue={ revenue }
              handleSubmitForm={ handleSubmitForm }
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

RevenueTransferPage.propTypes    = propTypes
RevenueTransferPage.defaultProps = defaultProps

export default RevenueTransferPage
